// extracted by mini-css-extract-plugin
export default {"notice":"RequiredDocumentsReviewStep_notice__zfvvL","list":"RequiredDocumentsReviewStep_list__N45Rg"};